import styled from "styled-components";

export const ConsentButton = styled.button`
  background-color: transparent;
  border: none;

  /* color: ${({ theme }) => theme.brandColors.primary}; */
  color: var(--p-color-text-interactive);
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  padding: 0 3px;
  text-decoration: underline;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`;
